// app/frontend/src/hooks/useSSE.js
import { useEffect, useRef } from "react";

export function useSSE(urlOrBuilder, { onMessage, onError, enabled = true } = {}) {
  const eventSourceRef = useRef(null);

  useEffect(() => {
    if (!enabled) {
      return;
    }

    // Build the base URL
    const baseUrl =
      typeof urlOrBuilder === "function" ? urlOrBuilder() : urlOrBuilder;

    if (!baseUrl) return;

    // Pull token from localStorage
    let token = null;
    try {
      token = window.localStorage.getItem("token");
    } catch {
      token = null;
    }

    // Always append token as query param if present
    let finalUrl = baseUrl;
    if (token) {
      const sep = baseUrl.includes("?") ? "&" : "?";
      finalUrl = `${baseUrl}${sep}access_token=${encodeURIComponent(token)}`;
    }

    // Debug so you can see the REAL URL now
    console.debug("[useSSE] connecting to:", finalUrl);

    const es = new EventSource(finalUrl);
    eventSourceRef.current = es;

    es.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        onMessage && onMessage(data);
      } catch (err) {
        onError && onError(err);
      }
    };

    es.onerror = (err) => {
      onError && onError(err);
      // Browser will auto-reconnect; we just log
      console.warn("[useSSE] error, browser will retry:", err);
    };

    return () => {
      if (eventSourceRef.current) {
        eventSourceRef.current.close();
        eventSourceRef.current = null;
      }
    };
  }, [urlOrBuilder, enabled, onMessage, onError]);
}

// Export as default for backwards compatibility
export default useSSE;
